const initialState = {
    qualification: [],
};

const qualificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_QUALIFICATION_NAME":
            return state = {
                ...state,
                qualification: [action.payload, ...state.qualification ],
            }
        case "UPDATE_QUALIFICATION_NAME":
            return state = { ...state, qualification: state?.qualification?.map((qualification) => qualification._id === action.payload._id ? action?.payload : qualification)}

        case "UPDATE_QUALIFICATION_STATUS":
            return state = {
                ...state,
                qualification: state?.qualification?.map((qualification) =>
                    qualification._id === action.payload._id ? action?.payload : qualification
                ),
            }
            case "GET_ALL_QUALIFICATIONS":
                return {
                    ...state,
                    qualification: action.payload,
                };
        default:
            return state;
    }
}

export default qualificationReducer;